// extracted by mini-css-extract-plugin
module.exports = {"attachButton":"styles_attachButton__3YX-e","attachSection":"styles_attachSection__2S_rE","select":"styles_select__3vqqN","switchContainer":"styles_switchContainer__1trtg"};